import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {selectEnv} from 'reducers/env';
import {getInvite, selectInvite} from 'api/invite';

import {goAfterLogin} from 'utils/AuthService';

const namespace = 'flows/lead/invite';

// Actions
const LOAD_LEAD_INVITE = defineAction('LOAD_LEAD_INVITE', namespace);
const SUBMIT_LEAD_INVITE = defineAction('SUBMIT_LEAD_INVITE', namespace);

export const loadLeadInvite = createAction(LOAD_LEAD_INVITE.ACTION);
export const submitLeadInvite = createAction(SUBMIT_LEAD_INVITE.ACTION);

// Lead Invite Saga
export function* leadInviteSaga({payload}) {
  const {id} = payload;

  // Get the invite when the page loads
  // TODO: skip this page if already logged in
  yield put(getInvite({id: payload.id}));

  // Wait for the user to click the login link
  yield take(SUBMIT_LEAD_INVITE.ACTION);

  // Take them to the login page, with a post-login redirect
  const env = yield select(selectEnv);
  const {deal: {self: deal}, self: invite} = (yield select(selectInvite, id)).data;
  if (env.web) {
    // Go here after login, with guest = true since user may not exist yet
    yield call(goAfterLogin, `/lead${deal}${invite}`, true);
    yield call(browserHistory.push, '/login');
  }
}

export function* sagas() {
  yield takeLatest(LOAD_LEAD_INVITE.ACTION, leadInviteSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/lead/invite/index.js